import { Transform } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class StudentCourseNoteModel {
	notes: string;
	@Transform(dateTransformer)
	updated: Date;
}
